import {
  SF852013, SF85, SF85P, SF85PS, SF86, PVQ_A, PVQ_A_B, PVQ_A_B_C, PVQ_A_B_D, FormTypes
} from 'constants/formTypes';

export const requiredByForms = (formType: FormTypes, forms: string[] = []) => forms.includes(formType);

export const requireHistoryEmployeeSupervisorPhysicalAddress = (formType: FormTypes) => requiredByForms(formType, [SF852013]);

export const requireHistoryFederalSection = (formType: FormTypes) => requiredByForms(
  formType,
  [SF86, SF85P, SF85PS, PVQ_A, PVQ_A_B, PVQ_A_B_C, PVQ_A_B_D]
);

export const requireMultipleCitizenshipRenounced = (formType: FormTypes) => requiredByForms(formType, [SF86]);

export const requireCitizenshipForeignPassportsSection = (formType: FormTypes) => requiredByForms(formType, [SF86, SF85P, SF85PS]);

export const requireForeignMilitaryMaintainsContact = (formType: FormTypes) => requiredByForms(formType, [SF86]);

export const requireForeignContactsSection = (formType: FormTypes) => requiredByForms(formType, [SF86]);

export const requireForeignContactAPOFPOIDK = (formType: FormTypes) => requiredByForms(formType, [SF86]);

export const requireForeignActivitiesSection = (formType: FormTypes) => requiredByForms(formType, [SF86]);

export const requireForeignBusinessSection = (formType: FormTypes) => requiredByForms(formType, [SF86]);

export const requireForeignTravelSection = (formType: FormTypes) => requiredByForms(formType, [SF86, SF85P, SF85PS]);

export const requireFinancialBankruptcySection = (formType: FormTypes) => requiredByForms(formType, [SF86, SF85P, SF85PS, PVQ_A, PVQ_A_B, PVQ_A_B_C, PVQ_A_B_D]);

export const requireFinancialAlimonySection = (formType: FormTypes) => requiredByForms(formType, [PVQ_A_B, PVQ_A_B_C, PVQ_A_B_D]);

export const requireFinancialAssetSeizedSection = (formType: FormTypes) => requiredByForms(formType, [PVQ_A_B, PVQ_A_B_C, PVQ_A_B_D]);

export const requireFinancialChildSupportSection = (formType: FormTypes) => requiredByForms(formType, [PVQ_A_B, PVQ_A_B_C, PVQ_A_B_D]);

export const requireFinancialCivilJudgementSection = (formType: FormTypes) => requiredByForms(formType, [PVQ_A_B, PVQ_A_B_C, PVQ_A_B_D]);

export const requireFinancialEvictionSection = (formType: FormTypes) => requiredByForms(formType, [PVQ_A_B, PVQ_A_B_C, PVQ_A_B_D]);

export const requireFinancialForeclosureSection = (formType: FormTypes) => requiredByForms(formType, [PVQ_A_B, PVQ_A_B_C, PVQ_A_B_D]);

export const requireFinancialLienSection = (formType: FormTypes) => requiredByForms(formType, [PVQ_A_B, PVQ_A_B_C, PVQ_A_B_D]);

export const requireFinancialRepossessionSection = (formType: FormTypes) => requiredByForms(formType, [PVQ_A_B, PVQ_A_B_C, PVQ_A_B_D]);

export const requireFinancialNonpaymentNonfederalSection = (formType: FormTypes) => requiredByForms(formType, [PVQ_A_B, PVQ_A_B_C, PVQ_A_B_D]);

export const requireFinancialBankruptcyTrusteeInformation = (formType: FormTypes) => requiredByForms(formType, [SF85P, SF85PS]);

export const requireFinancialGamblingSection = (formType: FormTypes) => requiredByForms(formType, [SF86, SF85P, SF85PS]);

export const requireFinancialTaxesSection = (formType: FormTypes) => requiredByForms(formType, [SF86, SF85, SF85P, SF85PS]);

export const requireFinancialFederalDebtSection = (formType: FormTypes) => requiredByForms(formType, [PVQ_A, PVQ_A_B, PVQ_A_B_C, PVQ_A_B_D]);

export const requireFinancialCardSection = (formType: FormTypes) => requiredByForms(formType, [SF86, SF85P, SF85PS, PVQ_A, PVQ_A_B, PVQ_A_B_C, PVQ_A_B_D]);

export const requireFinancialCreditSection = (formType: FormTypes) => requiredByForms(formType, [SF86, SF85P, SF85PS, PVQ_A, PVQ_A_B, PVQ_A_B_C, PVQ_A_B_D]);

export const requireFinancialDelinquentSection = (formType: FormTypes) => (
  requiredByForms(formType, [SF86, SF85, SF85P, SF85PS, PVQ_A_B, PVQ_A_B_C, PVQ_A_B_D]));

export const requireFinancialDelinquentName = (formType: FormTypes) => requiredByForms(formType, [SF86, SF85P, SF85PS]);

export const requireFinancialDelinquentInfraction = (formType: FormTypes) => requiredByForms(formType, [SF86, SF85P, SF85PS]);

export const allowFinancialDelinquentNonFederal = (formType: FormTypes) => requiredByForms(formType, [SF86, SF85P, SF85PS]);

export const requireFinancialNonpaymentSection = (formType: FormTypes) => requiredByForms(formType, [SF86, SF85P, SF85PS]);

export const requireDrugWhileSafetySection = (formType: FormTypes) => requiredByForms(formType, [SF86, SF85P, SF85PS]);

export const requireDrugWithClearanceSection = (formType: FormTypes) => requiredByForms(formType, [SF86]);

export const requireDrugSupplementalSection = (formType: FormTypes) => requiredByForms(formType, [SF85PS]);

export const requireAlcoholSections = (formType: FormTypes) => requiredByForms(formType, [SF86, SF85P, SF85PS]);

export const requireAlcoholReceivedCounselingsSection = (formType: FormTypes) => requiredByForms(formType, [SF86]);

export const requireAlcoholSupplementalSection = (formType: FormTypes) => requiredByForms(formType, [SF85PS]);

export const requireDrugWhileSafety = (formType: FormTypes) => requiredByForms(formType, [SF86, SF85P, SF85PS]);

export const requireDrugWithClearance = (formType: FormTypes) => requiredByForms(formType, [SF86, SF85P, SF85PS]);

export const requireDrugInFuture = (formType: FormTypes) => requiredByForms(formType, [SF86, SF85P, SF85PS]);

export const requireLegalOtherOffensesSection = (formType: FormTypes) => requiredByForms(formType, [SF86, SF85P, SF85PS]);

export const requireLegalNonCriminalCourtSection = (formType: FormTypes) => requiredByForms(formType, [SF86, SF85P, SF85PS]);

export const requireLegalTechnologySection = (formType: FormTypes) => requiredByForms(formType, [SF86, SF85P, SF85PS]);

export const requireLegalOffenseInvolvements = (formType: FormTypes) => requiredByForms(
  formType,
  [SF86, SF85P, SF85PS, PVQ_A, PVQ_A_B, PVQ_A_B_C, PVQ_A_B_D]
);

export const requireLegalOffenseSentenced = (formType: FormTypes) => requiredByForms(
  formType,
  [SF86, SF85P, SF85PS, PVQ_A, PVQ_A_B, PVQ_A_B_C, PVQ_A_B_D]
);

export const requireLegalOffenseIncarcerated = (formType: FormTypes) => requiredByForms(formType, [SF86, SF85P, SF85PS]);

export const requireLegalInvestigationClearanceGranted = (formType: FormTypes) => requiredByForms(formType, [SF85]);

export const requireLegalPoliceFirearms = (formType: FormTypes) => requiredByForms(formType, [SF86]);

export const requireLegalPoliceDrugs = (formType: FormTypes) => requiredByForms(formType, [SF86]);

export const requireForeignCounterIntelligence = (formType: FormTypes) => requiredByForms(formType, [SF86]);

export const requireForeignExcessiveKnowledge = (formType: FormTypes) => requiredByForms(formType, [SF86]);

export const requireForeignSensitiveInformation = (formType: FormTypes) => requiredByForms(formType, [SF86]);

export const requireForeignThreatened = (formType: FormTypes) => requiredByForms(formType, [SF86]);

export const requireAlcoholOrderedCounselingParty = (formType: FormTypes) => requiredByForms(formType, [SF86]);

export const requireFinancialCardDisciplinaryDate = (formType: FormTypes) => requiredByForms(formType, [SF86]);

export const requireRelationshipMaritalForeignBornDocExpiration = (formType: FormTypes) => requiredByForms(formType, [SF86]);

export const requireRelationshipMaritalDivorcePhoneNumber = (formType: FormTypes) => requiredByForms(formType, [SF86]);

export const requireRelationshipCohabitantSSN = (formType: FormTypes) => requiredByForms(formType, [SF86, SF85P, SF85PS]);

export const requireRelationshipMaritalSSN = (formType: FormTypes) => requiredByForms(formType, [SF86, SF85P, SF85PS, PVQ_A_B, PVQ_A_B_C, PVQ_A_B_D]);

export const requireRelationshipRelativesForeignBornDoc = (formType: FormTypes) => requiredByForms(formType, [SF86]);

export const requireRelationshipRelativesUSResidenceDoc = (formType: FormTypes) => requiredByForms(formType, [SF86]);

export const requireRelationshipRelativesForeignGovtAffExplanation = (formType: FormTypes) => requiredByForms(formType, [SF86]);

export const requireMilitaryHasServedMerchantMarine = (formType: FormTypes) => requiredByForms(formType, [SF852013]);

export const requireMilitaryCountry = (formType: FormTypes) => requiredByForms(formType, [SF852013]);

export const requireMilitaryHasBeenDischarged = (formType: FormTypes) => requiredByForms(formType, [SF86, SF85, SF85P, SF85PS]);

export const requireIdentificationContactInfo = (formType: FormTypes) => requiredByForms(
  formType,
  [SF86, SF85, SF85P, SF85PS, PVQ_A, PVQ_A_B, PVQ_A_B_C, PVQ_A_B_D]
);

export const requireRelationshipsPeopleName2013 = (formType: FormTypes) => requiredByForms(formType, [SF852013]);

export const requireRelationshipsPeopleRelationship = (formType: FormTypes) => (
  requiredByForms(formType, [SF86, SF85, SF85P, SF85PS])
);

export const requireRelationshipsPeopleRank = (formType: FormTypes) => requiredByForms(formType, [SF86, SF85, SF85P, SF85PS]);

export const requireRelationshipsPeopleEmail = (formType: FormTypes) => requiredByForms(formType, [SF86, SF85, SF85P, SF85PS]);

export const requireRelationshipRelativesAPOFPOIDK = (formType: FormTypes) => requiredByForms(formType, [SF86, SF85P, SF85PS]);

export const requireIdentificationPhysicalHeight = (formType: FormTypes) => (
  requiredByForms(formType, [SF86, SF85, SF85P, SF85PS])
);

export const requireIdentificationPhysicalWeight = (formType: FormTypes) => (
  requiredByForms(formType, [SF86, SF85, SF85P, SF85PS])
);

export const requireIdentificationPhysicalHairColor = (formType: FormTypes) => (
  requiredByForms(formType, [SF86, SF85, SF85P, SF85PS])
);

export const requireIdentificationPhysicalEyeColor = (formType: FormTypes) => (
  requiredByForms(formType, [SF86, SF85, SF85P, SF85PS])
);

export const requireHistoryResidenceRole = (formType: FormTypes) => requiredByForms(formType, [SF86, SF85, SF85P, SF85PS]);

// this captures ReferenceLastContact, ReferencePhoneEvening, ReferencePhoneDay, ReferencePhoneMobile,ReferenceRelationship, ReferenceAddress
export const requireHistoryResidenceReferenceInfo = (formType: FormTypes) => (
  requiredByForms(formType, [SF86, SF85, SF85P, SF85PS])
);

export const requireCitizenshipMultipleDates = (formType: FormTypes) => requiredByForms(
  formType,
  [SF86, SF85, SF85P, SF85PS, PVQ_A, PVQ_A_B, PVQ_A_B_C, PVQ_A_B_D]
);

export const requireCitizenshipMultipleCurrent = (formType: FormTypes) => (
  requiredByForms(formType, [SF86, SF85, SF85P, SF85PS])
);

export const requireCitizenshipMultipleHow = (formType: FormTypes) => requiredByForms(
  formType,
  [SF86, SF85, SF85P, SF85PS, PVQ_A, PVQ_A_B, PVQ_A_B_C, PVQ_A_B_D]
);

export const requireEmploymentHistorySupervisorEmail = (formType: FormTypes) => (
  requiredByForms(formType, [SF86, SF85, SF85P, SF85PS])
);

export const requireEmploymentItemStatus = (formType: FormTypes) => requiredByForms(formType, [SF86, SF85, SF85P, SF85PS]);

export const requireEmploymentItemLeft = (formType: FormTypes) => requiredByForms(
  formType,
  [SF86, SF85, SF85P, SF85PS, PVQ_A, PVQ_A_B, PVQ_A_B_C, PVQ_A_B_D]
);

export const requireEmploymentItemNonGovernment = (formType: FormTypes) => (
  requiredByForms(formType, [SF86, SF85, SF85P, SF85PS])
);

export const requireEmploymentItemSelfEmploymentVerify = (formType: FormTypes) => (
  requiredByForms(formType, [SF86, SF85, SF85P, SF85PS])
);

export const requireSupervisorHasDifferentAddress = (formType: FormTypes) => requiredByForms(formType, [SF852013]);

export const requireSupervisorAddress = (formType: FormTypes) => requiredByForms(formType, [SF86, SF85, SF85P, SF85PS]);

export const requireEmploymentSelfEmployedJobLocation = (formType: FormTypes) => (
  requiredByForms(formType, [SF86, SF85, SF85P, SF85PS])
);

export const requireCitizenshipStatusMaidenName = (formType: FormTypes) => requiredByForms(formType, [SF852013]);

export const requireCitizenshipStatusForm240Date = (formType: FormTypes) => requiredByForms(formType, [SF852013]);

export const requireCitizenshipStatusForm240DateExplanation = (formType: FormTypes) => requiredByForms(formType, [SF852013]);

export const requireCitizenshipUsPassportExpiration = (formType: FormTypes) => (
  requiredByForms(formType, [SF86, SF85, SF85P, SF85PS])
);

export const requireCitizenshipUsPassportName = (formType: FormTypes) => requiredByForms(formType, [SF86, SF85, SF85P, SF85PS]);

export const requireIdentificationOtherNameExplanation = (formType: FormTypes) => (
  requiredByForms(formType, [SF86, SF85, SF85P, SF85PS, PVQ_A, PVQ_A_B, PVQ_A_B_C, PVQ_A_B_D])
);

export const requireCitizenshipStatusResidenceStatus = (formType: FormTypes) => (
  requiredByForms(formType, [SF86, SF85P, SF85PS, SF85, PVQ_A, PVQ_A_B, PVQ_A_B_C, PVQ_A_B_D])
);

export const requireCitizenshipStatusAlienRegistrationExpiration = (formType: FormTypes) => (
  requiredByForms(formType, [SF86, SF85P, SF85PS, SF85, PVQ_A, PVQ_A_B, PVQ_A_B_C, PVQ_A_B_D])
);

export const requireCitizenshipStatusNotCitizenDocumentFields = (formType: FormTypes) => (
  requiredByForms(formType, [SF86, SF85P, SF85PS, SF85, PVQ_A, PVQ_A_B, PVQ_A_B_C, PVQ_A_B_D])
);

export const requireCitizenshipStatusNaturalizedFields = (formType: FormTypes) => (
  requiredByForms(formType, [SF86, SF85P, SF85PS, SF85, PVQ_A, PVQ_A_B, PVQ_A_B_C, PVQ_A_B_D])
);

export const requireCitizenshipStatusCitizenshipCertificateFields = (formType: FormTypes) => requiredByForms(formType, [SF852013]);

export const requireCitizenshipStatusForeignBorn = (formType: FormTypes) => (
  requiredByForms(formType, [SF86, SF85P, SF85PS, SF85, PVQ_A, PVQ_A_B, PVQ_A_B_C, PVQ_A_B_D])
);

export const requireCitizenshipStatusDerived = (formType: FormTypes) => requiredByForms(
  formType,
  [SF86, SF85P, SF85PS, SF85, PVQ_A, PVQ_A_B, PVQ_A_B_C, PVQ_A_B_D]
);

export const requireHistoryResidenceReferenceName = (formType: FormTypes) => (
  requiredByForms(formType, [SF86, SF85, SF85P, SF85PS])
);

export const requireHistoryEducationReferenceFields = (formType: FormTypes) => (
  requiredByForms(formType, [SF86, SF85, SF85P, SF85PS, PVQ_A, PVQ_A_B, PVQ_A_B_C, PVQ_A_B_D])
);

export const requireRelationshipRelativesAdditionalFamily = (formType: FormTypes) => requiredByForms(formType, [SF85P, SF85PS]);
